export default function Badge({
  variant = "info",
  dot = false,
  className = "",
  children,
  title,
}) {
  const variantMap = {
    default: "neutral",
    booked: "success",
    requested: "warning",
    cancelled: "danger",
    dropped: "danger",
    muted: "neutral",
  };
  const normalizedVariant = variantMap[variant] || variant;
  const classes = ["badge", `badge-${normalizedVariant}`];

  if (variant !== normalizedVariant) {
    classes.push(`badge-${variant}`);
  }

  if (dot) {
    classes.push("badge-with-dot");
  }

  if (className) {
    classes.push(className);
  }

  return (
    <span className={classes.join(" ")} title={title}>
      {dot ? <span className="badge-dot" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
